import { SEARCH_STACK_SUGGESTIONS_DICTIONARY } from "constants/stack";
import makeUseLabelCellFilterAction, {
  UseLabelCellFilterActionProps,
} from "ds/components/Table/helpers/makeUseLabelCellFilterAction";

import useStackListAnalytics from "../useStackListAnalytics";

const useLabelCellFilterAction = (props: UseLabelCellFilterActionProps = {}) => {
  return makeUseLabelCellFilterAction({
    trackAnalytics: useStackListAnalytics(),
    searchSuggestionsDictionary: SEARCH_STACK_SUGGESTIONS_DICTIONARY,
  })(props);
};

export default useLabelCellFilterAction;
